import genericApi from './genericApi';

import ApiResponse from '../models/ApiResponse';
import DeliveryCompany from '../models/DeliveryCompany';
import TruckDriverData from '../models/TruckDriverData';

const deliveryCompanyRequestHandler = {

  getDeliveryCompanies: (): Promise<ApiResponse<DeliveryCompany[]>> => {

    return genericApi.get('delivery_company');
  },

  getTruckDrivers: (): Promise<ApiResponse<TruckDriverData[]>> => {

    return genericApi.get('driver');
  },

  addNewDeliveryCompany: (deliveryCompany: DeliveryCompany): Promise<ApiResponse<DeliveryCompany[]>> => {
    
    return genericApi.put('delivery_company', deliveryCompany);
  },

  addNewTruckDriver: (driver: TruckDriverData): Promise<ApiResponse<TruckDriverData[]>> => {
    
    return genericApi.put('driver', driver);
  },

  getDeliveryCompanyById: (id: number| undefined): Promise<ApiResponse<DeliveryCompany>> => {
    return genericApi.get('delivery_company/' + id);
  },

  getDriverById: (id: number| undefined): Promise<ApiResponse<TruckDriverData>> => {
    return genericApi.get('driver/' + id);
  }
}

export default deliveryCompanyRequestHandler;